/**
 * Veridex Protocol SDK - Solana Chain Module
 */

export { SolanaClient } from './SolanaClient.js';
export type { SolanaClientConfig } from './SolanaClient.js';
